import { ChangeEvent, FC } from 'react';
import { Box, TextField, Typography } from '@material-ui/core';
import { ErrorMessage, Field } from 'formik';
import { useStyles } from '../../styles';

interface Props {
    value: string;
    handleChange: (e: ChangeEvent) => void;
}

const TitleField: FC<Props> = ({ value, handleChange }) => {
    const classes = useStyles();

    return (
        <Box className={classes.row}>
            <Typography className={classes.label}>{`Live Event title, You have ${
                120 - value.length
            } characters left`}</Typography>
            <Field
                placeholder="Your event title"
                component={TextField}
                autoComplete="off"
                variant="outlined"
                value={value}
                onChange={handleChange}
                InputProps={{ name: 'title', className: classes.field }}
                fullWidth
            />
            <p className={classes.errorText}>
                <ErrorMessage name="title" />
            </p>
        </Box>
    );
};

export default TitleField;
